import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Data } from '../../helpers';
import { DashboardService } from '../../dashboard';
var UpgradeComponent = /** @class */ (function () {
    function UpgradeComponent(data, dashboardService, router, route) {
        this.data = data;
        this.dashboardService = dashboardService;
        this.router = router;
        this.route = route;
        this.upgradePlans = [];
        this.upgradePlansdetails = {};
        this.features = {};
        this.planselected = '';
        this.payPalId = '';
        this.loading = false;
        this.msgTitle = "";
        this.msgContent = "";
        this.popUp = false;
        this.currentPlan = {};
        this.status = "";
        this.basicPopup = false;
        this.basicPlan = {};
        this.basicPlanCheck = {};
    }
    UpgradeComponent.prototype.editDisplay = function (edit) {
        if (edit) {
            return "block";
        }
        else {
            return "none";
        }
    };
    UpgradeComponent.prototype.planSelect = function (e) {
        if (e.target.checked) {
            this.planselected = e.target.value;
        }
        else {
            this.planselected = '';
        }
    };
    UpgradeComponent.prototype.paymentSuccess = function () {
        var _this = this;
        this.route.queryParams.subscribe(function (params) {
            _this.status = params['payment'] || 0;
        });
    };
    UpgradeComponent.prototype.ngOnInit = function () {
        this.initFn();
    };
    UpgradeComponent.prototype.initFn = function () {
        var _this = this;
        this.dashboardService.upgradePlansall().subscribe(function (data) {
            console.log(data);
            _this.upgradePlans = data;
            _this.upgradePlansdetails = data.keys;
            _this.currentPlan = data.myPlan;
            var temp = [];
            // console.log("index"+this.upgradePlansdetails['Offer New Course / Training']);
            var upgradePlan = _this.upgradePlansdetails;
            var CurrentPlanNewArr = _this.upgradePlansdetails['CurrentPlanNew'];
            _this.upgradePlansdetails.FeatureNames.forEach(function (current_value, index, initial_array) {
                temp[current_value] = [];
                upgradePlan[current_value].forEach(function (current_value1, index1, initial_array1) {
                    temp[current_value].push(current_value1);
                });
            });
            _this.features = temp;
            _this.paymentSuccess();
            if (_this.status == 'success') {
                _this.msgTitle = "Success";
                _this.msgContent = "Congratulations! your membership is now " + _this.currentPlan.planType;
                _this.popUp = true;
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
        });
    };
    UpgradeComponent.prototype.BacisSelect = function () {
        var _this = this;
        //this.router.navigate(['dashboard/upgradeplan']);
        this.basicPlanCheck.paypalId = this.basicPlan.payPalMonthlyId.toString();
        var url = location.href;
        this.basicPlanCheck.cancelUrl = url.replace("upgradeplan", "upgrade?payment=cancel");
        this.basicPlanCheck.returnUrl = url.replace("upgradeplan", "upgrade?payment=success");
        this.basicPlanCheck.city = "malvern";
        this.basicPlanCheck.country = "US";
        this.basicPlanCheck.zip = "19355";
        this.basicPlanCheck.street = "56 Frazer";
        this.basicPlanCheck.state = "PA";
        console.log(this.basicPlanCheck);
        this.dashboardService.upgradePlanPaypal(this.basicPlanCheck).subscribe(function (data) {
            console.log(data);
            if (data.success == true && data.launch_url == "NONE") {
                _this.initFn();
                _this.msgTitle = "Success!!";
                _this.msgContent = "Your request has been confirmed and your account will not be charged in subsequent billing cycle.";
                _this.popUp = true;
                _this.basicPopup = false;
            }
            else {
                _this.msgTitle = "Error!!";
                _this.msgContent = data.error;
                _this.popUp = true;
                _this.basicPopup = false;
            }
        }, function (error) {
            if (error.Uvsity_Errors) {
                _this.msgTitle = "Error";
                _this.msgContent = error.Uvsity_Errors;
                _this.popUp = true;
            }
            _this.loading = false;
        });
    };
    UpgradeComponent.prototype.upGrade = function (index) {
        // console.log(index);
        // console.log(this.features['Membership Fee'][index]);
        // console.log(this.planselected);
        if (this.features['Membership Fee'][index].membershipFeePerMonth == 0) {
            this.basicPlan = this.features['Membership Fee'][index];
            this.data.storage = {
                payPalId: this.features['Membership Fee'][index].payPalMonthlyId,
                plan: this.features['Membership Fee'][index]
            };
            this.basicPopup = true;
        }
        else {
            if (this.planselected != '') {
                if (this.features['Membership Fee'][index].payPalMonthlyId == this.planselected ||
                    this.features['Membership Fee'][index].payPalYearlyId == this.planselected) {
                    this.data.storage = {
                        payPalId: this.planselected,
                        plan: this.features['Membership Fee'][index]
                    };
                    this.router.navigate(['dashboard/upgradeplan']);
                }
                else {
                    alert('Please Select Monthly Or Yearly.');
                }
            }
            else {
                alert('Please Select Monthly Or Yearly.');
            }
        }
    };
    return UpgradeComponent;
}());
export { UpgradeComponent };
//# sourceMappingURL=upgrade.component.js.map